import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import styles from './styles.module.scss';

import apiFooter from '../../../api/Footer';
// import apiProfeco from '../../../api/Profeco';
import LinkWrap from '../../Wraps/LinkWrap';

import { ReactComponent as LogoFooter } from '../../../assets/icons/logo-wide-color.svg';
import { ReactComponent as Facebook } from '../../../assets/icons/social-facebook.svg';
import { ReactComponent as Twitter } from '../../../assets/icons/social-twitter.svg';
import { ReactComponent as YouTube } from '../../../assets/icons/social-youtube.svg';
import { ReactComponent as Instagram } from '../../../assets/icons/social-instagram.svg';
import { ReactComponent as Pinterest } from '../../../assets/icons/social-pinterest.svg';
import { ReactComponent as CertaDSA } from '../../../assets/icons/certa-dsa.svg';
import { ReactComponent as CertaAMVD } from '../../../assets/icons/certa-amvd.svg';
// import { ReactComponent as ProfecoLogo } from '../../../assets/icons/distintivo-profeco.svg';
import Recognition from '../../../assets/icons/logo-recognition.png';

import { spanish } from '../../../config/config';

const Logo = () => (
  <div className={styles.logo}>
    <LogoFooter />
  </div>
);

const Certification = ({ data }) => {
  const { CertificationSpanish, CertificationEnglish } = data;
  return (
    <div className={styles.certification}>
      <div className={styles.certificationIcon}>
        <a
          href="https://www.amvd.org.mx"
          target="_blank"
          rel="noreferrer noopener"
        >
          <CertaAMVD />
        </a>
        <CertaDSA />
        <img src={Recognition} alt="Logo" />
      </div>
      <div className={styles.certificationText}>
        <ReactMarkdown
          children={spanish ? CertificationSpanish : CertificationEnglish}
        />
      </div>
    </div>
  );
};

const Copyright = ({ data }) => {
  const date = new Date();
  const year = date.getFullYear();
  return (
    <div className={styles.copyright}>
      <p>{`© ${year} - ${data?.Copyright}`}</p>
    </div>
  );
};

const Social = ({ data }) => (
  <div className={styles.social}>
    <h4 className={styles.title}>
      {spanish ? data?.SocialTitleSpanish : data?.SocialTitleEnglish}
    </h4>
    <nav className={styles.socialLinks}>
      {data?.Facebook && (
        <a href={data?.FacebookLink} target="_blank" rel="noreferrer noopener">
          <Facebook />
        </a>
      )}
      {data?.Twitter && (
        <a href={data?.TwitterLink} target="_blank" rel="noreferrer noopener">
          <Twitter />
        </a>
      )}
      {data?.YouTube && (
        <a href={data?.YoutubeLink} target="_blank" rel="noreferrer noopener">
          <YouTube />
        </a>
      )}
      {data?.Instagram && (
        <a href={data?.InstagramLink} target="_blank" rel="noreferrer noopener">
          <Instagram />
        </a>
      )}
      {data?.Pinterest && (
        <a href={data?.PinterestLink} target="_blank" rel="noreferrer noopener">
          <Pinterest />
        </a>
      )}
    </nav>
  </div>
);

const Nav = ({ data, title }) => (
  <div className={styles.nav}>
    <h4 className={styles.title}>
      {spanish ? title?.LinksTitleSpanish : title?.LinksTitleEnglish}
    </h4>
    <nav className={styles.navLinks}>
      {data?.map((item, key) => (
        <LinkWrap to={item?.LinkTo} isExternal={item?.External} key={key}>
          {spanish ? item?.Name : item?.NameEnglish}
        </LinkWrap>
      ))}
    </nav>
  </div>
);

/* eslint-disable */
{
  /* const Profeco = () => {
  const [content, setContent] = useState(null);
  useEffect(async () => {
    setContent(await apiProfeco.getContent());
  }, []);
  return (
    <div className={styles.profeco}>
      <a href={content?.ProfecoLink} target="_blank" rel="noopener noreferrer">
        <ProfecoLogo />
      </a>
    </div>
  );
}; */
}

const Footer = () => {
  const [nav, setNav] = useState([]);
  const [content, setContent] = useState(null);
  const complete = nav.length && content !== null;
  useEffect(async () => {
    setNav(await apiFooter.getLinks());
    setContent(await apiFooter.getSocial());
  }, []);
  return (
    <div className={styles.container}>
      <div className={styles.separator} />
      {complete && (
        <div className={styles.content}>
          <Nav data={nav} title={content} />
          <Social data={content} />
          <Certification data={content} />
          <Logo />
          <Copyright data={content} />
          {/* <Profeco /> */}
        </div>
      )}
    </div>
  );
};

export default Footer;
